import { render, staticRenderFns } from "./BinsInput.vue?vue&type=template&id=1078c141&"
import script from "./BinsInput.vue?vue&type=script&lang=js&"
export * from "./BinsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports